

import { LoadingProps } from "Types/ViewTypes";
import { SplitLayout } from "../components/SplitLayout";
import Updater from "lib/containers/Updater";
export const LoadingView = (props: LoadingProps) => {
  return (
    <SplitLayout>
      <Updater {...props} type="wait" />
    </SplitLayout>
  )
}